import { StickyNote, type StickyNoteAction } from "../sticky-note";
export interface NotesStickyNoteProps {
  notes: string;
  action?: StickyNoteAction;
}
export const NotesStickyNote = ({ notes, action }: NotesStickyNoteProps) => {
  return <StickyNote title="Notes" line1={notes} action={action} />;
};
